import { useRef, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { initializeFacebookJSSDK } from '../redux/actions';
import logger from '../logger';
import { isFacebookSDKInitialized } from '../redux/selectors';
import { loadScript } from '../utils';
const SCRIPT_ID = 'facebook-js-sdk';
const SCRIPT_SRC = 'https://connect.facebook.net/en_US/sdk.js';
export default function useFacebookSignIn(appId, onSuccess) {
    const sdkState = useRef('not-ready');
    const isInitialized = useSelector(isFacebookSDKInitialized);
    const dispatch = useDispatch();
    const doSignIn = useCallback(()=>{
        FB.login((response)=>{
            logger.info('Facebook auth response ', response.authResponse);
            onSuccess(response);
        }, {
            scope: 'email'
        });
    }, [
        onSuccess
    ]);
    useEffect(()=>{
        if (typeof window !== 'undefined' && !window.fbAsyncInit && !isInitialized) {
            window.fbAsyncInit = function() {
                logger.info('fbAsyncInit called');
                FB.init({
                    appId,
                    xfbml: false,
                    version: 'v14.0'
                });
                dispatch(initializeFacebookJSSDK());
                sdkState.current = 'ready';
                doSignIn();
            };
        }
    }, [
        isInitialized,
        appId,
        dispatch,
        doSignIn
    ]);
    const signIn = ()=>{
        switch(sdkState.current){
            case 'not-ready':
                sdkState.current = 'loading';
                loadScript(SCRIPT_ID, SCRIPT_SRC);
                break;
            case 'ready':
                doSignIn();
                break;
            case 'loading':
            default:
                break;
        }
    };
    return {
        signIn
    };
}
